import React from "react";
import { Link } from "react-router-dom";
import "./Team.css";
import Button from "@material-ui/core/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const Team = (props) => {
  const { strTeam, strSport, strTeamBadge, idTeam } = props.team;
  return (
    <div className="body">
      <div className="team-card">
        <img src={strTeamBadge} alt="Badge" />
        <h1>{strTeam}</h1>
        <h5>Sports Type: {strSport}</h5>
        <Link to={`/team/${idTeam}`} style={{ textDecoration: "none" }}>
          <Button variant="contained" color="primary">
            Explore{" "}
            <span>
              <FontAwesomeIcon icon={faArrowRight} />
            </span>
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default Team;
